import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {SectionCard} = _components;
  if (!SectionCard) _missingMdxReference("SectionCard", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(SectionCard, {
      title: "Welcome to CompuBio",
      children: [_jsx("p", {
        children: _jsxs(_components.p, {
          children: [_jsx("strong", {
            children: "CompuBio"
          }), " is a next-generation, AI-powered bioinformatics platform\nbuilt to transform raw biological data into confident, reproducible insight — at scale."]
        })
      }), _jsx("p", {
        children: _jsxs(_components.p, {
          children: ["From ", _jsx("strong", {
            children: "genomics"
          }), " and ", _jsx("strong", {
            children: "metagenomics"
          }), " to\n", _jsx("strong", {
            children: "machine learning"
          }), " and interactive visual analytics, CompuBio\nunifies the entire bioinformatics lifecycle into a single, secure,\nproduction-ready environment."]
        })
      }), _jsx("p", {
        children: _jsxs(_components.p, {
          children: ["Whether you are a ", _jsx("strong", {
            children: "researcher"
          }), ", ", _jsx("strong", {
            children: "clinician"
          }), ", or\n", _jsx("strong", {
            children: "data scientist"
          }), ", CompuBio removes the friction between sequencing,\ncomputation, interpretation, and decision-making."]
        })
      })]
    }), "\n", _jsxs(SectionCard, {
      title: "The Problem We Solve",
      children: [_jsxs("ul", {
        children: [_jsx("li", {
          children: " Fragmented scripts, tools, and environments"
        }), _jsx("li", {
          children: " Poor reproducibility across machines and operating systems"
        }), _jsx("li", {
          children: " Slow iteration, validation, and auditing"
        }), _jsx("li", {
          children: " Inaccessible to non-programmers"
        }), _jsx("li", {
          children: " Disconnected from interpretation and reporting"
        })]
      }), _jsx("p", {
        children: _jsxs(_components.p, {
          children: ["As datasets grow larger and analyses become more complex, these limitations\ndirectly slow down ", _jsx("strong", {
            children: "discovery"
          }), ", ", _jsx("strong", {
            children: "diagnostics"
          }), ", and\n", _jsx("strong", {
            children: "innovation"
          }), "."]
        })
      })]
    }), "\n", _jsxs(SectionCard, {
      title: "Why CompuBio?",
      children: [_jsx("p", {
        children: _jsx(_components.p, {
          children: "CompuBio was designed from the ground up to eliminate these bottlenecks."
        })
      }), _jsxs("ul", {
        children: [_jsxs("li", {
          children: [_jsx("strong", {
            children: "Unified end-to-end pipelines"
          }), " — no tool hopping"]
        }), _jsxs("li", {
          children: [_jsx("strong", {
            children: "Reproducibility by design"
          }), " — containerized & versioned"]
        }), _jsxs("li", {
          children: [_jsx("strong", {
            children: "AI-assisted interpretation"
          }), " — explainable, not black-box"]
        }), _jsxs("li", {
          children: [_jsx("strong", {
            children: "Interactive dashboards"
          }), " — no static PDFs"]
        }), _jsxs("li", {
          children: [_jsx("strong", {
            children: "Secure SaaS architecture"
          }), " — cloud-native & scalable"]
        })]
      })]
    }), "\n", _jsx(SectionCard, {
      title: "Core Capabilities",
      children: _jsxs("ul", {
        children: [_jsxs("li", {
          children: [_jsx("strong", {
            children: "Variant Calling & Annotation"
          }), " (DNA / RNA, VCF)"]
        }), _jsx("li", {
          children: _jsx("strong", {
            children: "Microbial & Metagenomic Profiling"
          })
        }), _jsx("li", {
          children: _jsx("strong", {
            children: "GWAS & Population Genomics"
          })
        }), _jsx("li", {
          children: _jsx("strong", {
            children: "Machine Learning & AI"
          })
        }), _jsx("li", {
          children: _jsx("strong", {
            children: "Custom Pipelines & Automation"
          })
        })]
      })
    }), "\n", _jsx(SectionCard, {
      title: "Who Is CompuBio For?",
      children: _jsxs("ul", {
        children: [_jsx("li", {
          children: " Researchers seeking reproducible, scalable analysis"
        }), _jsx("li", {
          children: " Clinicians needing fast, interpretable results"
        }), _jsx("li", {
          children: " Data Scientists applying AI to biological data"
        }), _jsx("li", {
          children: " Organizations building production-grade pipelines"
        })]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
